import React, { useEffect, useState } from "react";
import { fetchImage } from "../api/unsplash"; // Asegúrate de tener una función para el API de Unsplash

const CustomerReviews = ({ testimonials }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchPersonImages = async () => {
      try {
        const queries = Array.from({ length: 10 }, () => "face person");
        const imageResults = await Promise.all(
          queries.map((query) => fetchImage(query))
        );

        setImages(imageResults);
      } catch (error) {
        console.error("Error fetching person images:", error);
      }
    };

    fetchPersonImages();
  }, []);

  return (
    <section className="bg-green-50 py-10">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold text-center mb-8">Customer Reviews</h2>
        {testimonials && testimonials.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((review, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center"
              >
                <div className="mb-4">
                  <img
                    src={images[index % images.length] || "https://via.placeholder.com/150"}
                    alt={`Profile of ${review.Testimonials_name}`}
                    className="w-16 h-16 object-cover rounded-full border-2 border-gray-300"
                  />
                </div>
                <div className="text-pink-500 font-bold text-lg mb-2">
                  {review.Testimonials_name}
                </div>
                <p className="text-gray-600 mb-4">{review.Testimonials_description}</p>
                <div className="flex items-center justify-center space-x-2">
                  <span className="text-green-500">✔ Verified purchase</span>
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <span
                        key={i}
                        className={`text-yellow-400 ${
                          i < 5 ? "text-yellow-400" : "text-gray-300"
                        }`}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center">No reviews available</p>
        )}
      </div>
    </section>
  );
};

export default CustomerReviews;
